<div
  class="flex items-center justify-center rounded-full font-semibold text-white"
  [ngClass]="colorClass"
  [ngStyle]="{ width: size() + 'px', height: size() + 'px' }"
>
  {{ initials }}
</div>
